import { useEffect, useRef } from 'react';

const IS_ADSENSE_READY = true; // AdSense onayı gelince true yap

function AdSlot({ slot, format = 'auto', responsive = true, className = '' }) {
  const adRef = useRef(null);
  const pushed = useRef(false);

  useEffect(() => {
    if (!IS_ADSENSE_READY || pushed.current) return;
    try {
      if (window.adsbygoogle && adRef.current) {
        window.adsbygoogle.push({});
        pushed.current = true;
      }
    } catch (e) {
      /* AdSense not loaded yet */
    }
  }, []);

  if (!IS_ADSENSE_READY) {
    return (
      <div className={`ad-container ${className}`}>
        <span>Reklam Alanı</span>
      </div>
    );
  }

  return (
    <div className={`ad-container ${className}`}>
      <ins
        className="adsbygoogle"
        ref={adRef}
        style={{ display: 'block' }}
        data-ad-client="ca-pub-1696124947812541"
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={responsive ? 'true' : 'false'}
      />
    </div>
  );
}

export default AdSlot;
